import {IntermediatePart} from "../../intermediatePart";

export default class Dishwasher extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'dishwasher';
    this.partName = 'Dishwasher';
    this.translateId = "visualizer.kitchen.appliance.dishwasher";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Dishwasher());
  }
}
